import { render } from "./subjectFusion.vue?vue&type=template&id=079c1d86&scoped=true"
import script from "./subjectFusion.vue?vue&type=script&lang=js"
export * from "./subjectFusion.vue?vue&type=script&lang=js"

import "./subjectFusion.vue?vue&type=style&index=0&id=079c1d86&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079c1d86"]])

export default __exports__